import type { Action } from '../typings/reducers';

type GatewaysState = { gcSettingsModalIsOpen?: boolean } & Record<string, unknown>;

export default function (state: GatewaysState = {}, action: Action): GatewaysState {
  switch (action.type) {
    case 'TOGGLE_GC_SETTINGS_MODAL':
      return { ...state, gcSettingsModalIsOpen: !state.gcSettingsModalIsOpen };
    default:
      return state;
  }
}
